import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      levels: 'groupLevels/levels', // moduleName/getterName
    }),
  },
  methods: {
    ...mapActions({
      addLevels: 'groupLevels/ADDLEVELS',
      resetLevels: 'groupLevels/RESETLEVELS',
    }),
  },
};
